angular.module('imgLoad', []).

directive('imgLoad', ['$parse', '$timeout', function ($parse, $timeout) {
  return {
    restrict: 'A',
    link: function link(scope, elem, attrs) {
      var fn = $parse(attrs.imgLoad);
      elem.on('load', function (event) {
        scope.$apply(function () {
          fn(scope, { $event: event });
          // Do it again in 2 seconds
          $timeout(function () {
            fn(scope, { $event: event });
          }, 2000);

        });
      });
    } };

}]);